import Symbol from './Symbol';
import { SYMBOL_COUNT } from '@/pages/dsst-spick/dsstConfig';

interface SymbolMapProps {
  symbolMap: number[];
  setIndex?: number;
  symbolSizeClass?: string;
  highlightIndex?: number;
}

export default function SymbolMap({
  symbolMap,
  setIndex = 0,
  symbolSizeClass = 'w-8 h-8',
  highlightIndex = -1,
}: SymbolMapProps) {
  return (
    <div className="w-full grid grid-cols-6 gap-1 sm:gap-1.5">
      {Array.from({ length: SYMBOL_COUNT }, (_, i) => {
        const highlighted = i === highlightIndex;
        return (
          <div key={i} className="relative flex flex-col items-center gap-1">
            <div className="flex items-center justify-center text-accent-500">
              <Symbol symbolId={i} setIndex={setIndex} className={symbolSizeClass} />
            </div>
            <span className="text-sm font-semibold text-foreground-800 leading-none">
              {symbolMap[i]}
            </span>
            {highlighted && (
              <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-primary-600 text-white">
                <i className="ri-check-line text-base leading-none" />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}